import { render, staticRenderFns } from "./BillingsReport.vue?vue&type=template&id=4b9c5b37&"
import script from "./BillingsReport.vue?vue&type=script&lang=js&"
export * from "./BillingsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports